import React, { useState, useEffect, useCallback, useMemo } from "react";
import TeacherHeader from "../common/TeacherHeader";
import Footer from "../common/Footer";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import { baseUrl } from "../../Utility/constants";
import { getSchoolId, fetchSubjectGroupMaster } from "../../Utility/commonFunctions";
import useCurrentSession from "../../hooks/useCurrentSession";

const GraceMarksFeeding = () => {
  const [schoolId, setSchoolId] = useState(null);
  const [standards, setStandards] = useState([]);
  const [sections, setSections] = useState([]);
  const [streams, setStreams] = useState([]);
  const [subjectGroups, setSubjectGroups] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [students, setStudents] = useState([]);
  const { currentSession, loading: sessionLoading } = useCurrentSession();

  const [selected, setSelected] = useState({
    standardId: "",
    sectionId: "",
    streamId: "",
    subjectGroupId: "",
    subjectId: ""
  });

  // 🔹 Modal State
  const [showModal, setShowModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [graceMarks, setGraceMarks] = useState("");

 
  // ✅ Subjects
  const fetchSubjects = useCallback(async () => {
    
    const res = await axios.get(`${baseUrl}/api/SubjectMaster/GetSubjectMasterForGraceMarksByTeacherId`, {
      params: {        
        teacherId: localStorage.getItem("userID")
      },
    });

    setSubjects(res.data);
  }, [selected]);

  useEffect(() => { fetchSubjects(); }, []);

  const fetchStudents = useCallback(async () => {
    const { subjectId } = selected;

    if (!subjectId) {
      setStudents([]);
      return;
    }
    setStudents([]);
    try {
      const { data } = await axios.get(
        `${baseUrl}/api/MarksFeeding/StudentResultSummaryByTeacherId`,
        {
          params: {
            teacherId: localStorage.getItem("userID"),
            subjectId,
          }
        }
      );

      setStudents(data || []);
    } catch {
      setStudents([]);
    }
  }, [selected]);

  useEffect(() => { fetchStudents(); }, [fetchStudents]);

  // 🔹 Input Validation
  const handleGraceChange = (e) => {
    let value = e.target.value;

    if (!/^\d*$/.test(value)) return;

    if (Number(value) > 10) {
      toast.warning("Max 10 marks allowed");
      return;
    }

    setGraceMarks(value);
  };

  // 🔹 Save API
  const saveGraceMarks = async () => {
    if (!graceMarks) return toast.warning("Enter grace marks");

    try {
      await axios.post(`${baseUrl}/api/MarksFeeding/AddOrUpdateGraceMarks`, {
        studentId: selectedStudent.studentId,
        subjectId: selected.subjectId,
        sessionId: selectedStudent.sessionId,
        graceMarks: Number(graceMarks),
        createdBy: localStorage.getItem("userID")
      });

      toast.success("Saved successfully");
      setShowModal(false);
      fetchStudents();
    } catch (err) {
      toast.error(err?.response?.data || "Error saving");
    }
  };

  // 🔹 Format
  const formatMarks = (val) => val === -1 ? "Ab" : (val ?? 0);

  const dropdowns = useMemo(() => [
    // { label: "Standard", name: "standardId", options: standards, labelKey: "standardName", valueKey: "id" },
    // { label: "Section", name: "sectionId", options: sections, labelKey: "name", valueKey: "id" },
    // { label: "Stream", name: "streamId", options: streams, labelKey: "name", valueKey: "id" },
    // { label: "Group", name: "subjectGroupId", options: subjectGroups, labelKey: "subjectGroupName", valueKey: "subjectGroupId" },
    { label: "Subject", name: "subjectId", options: subjects, labelKey: "subjectName", valueKey: "subjectId" }
  ], [standards, sections, streams, subjectGroups, subjects]);

  return (
    <>
      <TeacherHeader />

      <div className="container mt-5 mb-5">
        <h3>Add Grace Marks</h3>
        {/* Filters */}
        <div className="row g-3">
          {dropdowns.map(d => (
            <div className="col-md-2" key={d.name}>
              <label>{d.label}</label>
              <select
                className="form-select"
                name={d.name}
                value={selected[d.name]}
                onChange={(e) => setSelected({ ...selected, [e.target.name]: e.target.value })}
              >
                <option value="">Select</option>
                {d.options.map(o => (
                  <option key={o[d.valueKey]} value={o[d.valueKey]}>
                    {o[d.labelKey]}
                  </option>
                ))}
              </select>
            </div>
          ))}
        </div>

        {/* TABLE */}
        <table className="table table-striped table-hover mt-4">
          <thead>
            <tr>
              <th>#</th>
              <th>Seat</th>
              <th>Name</th>
              <th>Unit1</th>
              <th>Unit2</th>
              <th>Term1</th>
              <th>Total A</th>
              <th>Theory</th>
              <th>Oral</th>
              <th>Total B</th>
              <th>Grand Total</th>
              <th>Average</th>
              <th>Grace</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {students.map((stu, i) => (
              <tr key={stu.studentId}>
                <td>{i + 1}</td>
                <td>{stu.examSeatNo}</td>
                <td>{stu.name}</td>
                <td>{formatMarks(stu.unit1)}</td>
                <td>{formatMarks(stu.unit2)}</td>
                <td>{formatMarks(stu.term1)}</td>
                <td>{stu.totalA}</td>
                <td>{formatMarks(stu.finalTheory)}</td>
                <td>{formatMarks(stu.finalOral)}</td>
                <td>{stu.totalB < 1 ? 0 : stu.totalB}</td>
                <td>{stu.grandTotal < 1 ? 0 : stu.grandTotal}</td>
                <td><b>{stu.average < 1 ? 0 : stu.average}</b></td>

                {/* NEW */}
                <td>{stu.graceMarks || 0}</td>

                <td>
                  {stu.graceMarks ? "Marks Added" :
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => {
                        setSelectedStudent(stu);
                        setGraceMarks(stu.graceMarks || "");
                        setShowModal(true);
                      }}
                    >
                      {/* {stu.graceMarks ? "Edit" : "Add"} */}
                      Add
                    </button>
                  }
                </td>
              </tr>
            ))}
          </tbody>
        </table>

      </div>

      {/* MODAL */}
      {showModal && (
        <>
          <div className="modal fade show d-block">
            <div className="modal-dialog">
              <div className="modal-content">

                <div className="modal-header">
                  <h5>Add Grace Marks</h5>
                  <button className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>

                <div className="modal-body">
                  <b>{selectedStudent?.name}</b>

                  <input
                    className="form-control mt-2"
                    value={graceMarks}
                    onChange={handleGraceChange}
                    placeholder="Enter marks (max 10)"
                  />
                </div>

                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Cancel
                  </button>
                  <button className="btn btn-success" onClick={saveGraceMarks}>
                    Save
                  </button>
                </div>

              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}

      <Footer />
      <ToastContainer />
    </>
  );
};

export default GraceMarksFeeding;